import type { ExchangeRateData } from './schemas';
import type { ExchangeRate } from '../model/types';

/** Anti-corruption: rate DTO → domain. Returns null when no usable numeric rate is present. */
export function toExchangeRate(data: ExchangeRateData): ExchangeRate | null {
  if (typeof data.rate !== 'number' || !Number.isFinite(data.rate)) return null;
  return {
    base: data.base ?? '',
    quote: data.quote ?? '',
    rate: data.rate,
    date: data.date ?? '',
  };
}
